import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../Layout/Layout";
import { ProgressBar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  ErrorMessage,
  Field,
  FieldArray,
  Formik,
  Form as FormikForm,
} from "formik";
import { userEditProfile } from "../redux/actions/userAuth";
import { Decryptedid, Encryptedid } from "../utils/BcruptEncyptid";
import Autocomplete from "react-google-autocomplete";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import useGetAddressIO from "../Hooks/getAddressIo";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Loader from "../Components/Loader";
import { getSalonProfileById, uploadImage } from "../redux/actions/userActions";
import { Modal } from "react-bootstrap";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";
export default function SignUpTwo() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { addressData, getAddress } = useGetAddressIO();
  var dcryptId = Decryptedid(atob(id));
  const [prevImg, setPrevImg] = useState();
  const [prevQualImg, setPrevQualImg] = useState();
  const [postcode, setPostcode] = useState();
  const [address1, setAddress1] = useState();
  const [address2, setAddress2] = useState();
  const [progress, setProgress] = useState(false);

  const [prevImg2, setPrevImg2] = useState();
  const [pdfFile, setPdfFile] = useState();
  const [pdfFile2, setPdfFile2] = useState();
  const { salonDetail } = useSelector((state) => ({
    salonDetail: state.userMgmtSlice.salonDetail,
  }));

  const [city, setCity] = useState();

  const handleKeyEnter = () => {
    getAddress(postcode);
  };

  const handleSearch = (e, setFieldValue) => {
    const data = addressData?.addresses?.find(
      (element) =>
        element?.formatted_address?.filter((item) => item !== "").join(", ") ==
        e.target.value?.toString()
    );
 
    setFieldValue("city", data?.town_or_city);
    setFieldValue("country", data?.country);
    setFieldValue("lat", addressData?.latitude);
    setFieldValue("long", addressData?.longitude);
  };

  useEffect(() => {
    dispatch(getSalonProfileById({ id: dcryptId, admin: "noclicks" }));
  }, [dcryptId]);

  useEffect(() => {
    setPostcode(salonDetail?.postcode);
    getAddress(salonDetail?.postcode);
  }, [salonDetail]);

  console.log(salonDetail, "salonDetail");
  const [show2, setShow2] = useState(false);

  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const initialValues = {
    qual_documents: [
      {
        doc_title: "",
        doc_image: "",
      },
    ],
  };

  const validationSchema = Yup.object().shape({
    qual_documents: Yup.array().of(
      Yup.object().shape({
        doc_title: Yup.string().required("Document title is required"),
        doc_image: Yup.mixed().required("Document file is required"),
      })
    ),
  });

  const handleSubmit = async (values) => {
    console.log(values, "values");
    values.id = salonDetail?._id;

    dispatch(userEditProfile(values)).then((data) => {
      if (data?.payload?.success) {
        toast.success(data?.payload?.message);
        dispatch(getSalonProfileById({ id: dcryptId, admin: "noclicks" }));
      }
    });
    handleClose2();
  };
  return (
    <>
      <Helmet>
        <title>Sign Up - Salon Rated</title>
        <meta name="description" content="Not Found" />
      </Helmet>
      <Layout>
        {/* Header section start  */}

        {/* Header section End */}

        {/* Sign Up Main Text start */}

        <section className="Sign-main-section">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="Sign-main-text">
                  <h2 className="RecifeDisplay common-heading">
                    Become a SalonRated Salon
                  </h2>
                  <p>
                    Becoming SalonRated ensures that every potential customer
                    can trust that you're fully insured, certified, and
                    committed to providing exceptional professional hair and
                    beauty services. This instills complete confidence in your
                    business.
                  </p>
                </div>
              </Col>
            </Row>
            <Formik
              enableReinitialize={true}
              initialValues={{
                business_name: salonDetail?.business_name || "",
                telephone_number: salonDetail?.telephone_number || "",
                business_email: salonDetail?.business_email || "",
                website_url: salonDetail?.website_url || "",
                address: salonDetail?.address || "",
                country: salonDetail?.country || "",
                city: salonDetail?.city || "",
                postcode: salonDetail?.postcode || "",
                insurance_certificate: salonDetail?.insurance_certificate || "",
                // qualification_certificate:
                //   salonDetail?.qualification_certificate || "",
                // opening_days: "",
                // opening_time: "",
                // closing_time: "",
                lgbt_friendly: salonDetail?.lgbt_friendly || false,
                lat: salonDetail?.lat || 0,
                long: salonDetail?.long || 0,
                insurance_expiry: salonDetail?.insurance_expiry || "",
              }}
              validate={(values) => {
                const errors = {};

                if (!values.business_name) {
                  errors.business_name = "Required*";
                }
                if (!values.telephone_number) {
                  errors.telephone_number = "Required*";
                }

                if (!values.website_url) {
                  errors.website_url = "Required*";
                }

                if (!values.business_email) {
                  errors.business_email = "Required*";
                } else if (
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                    values.business_email
                  )
                ) {
                  errors.business_email = "Invalid email address";
                }

                if (!values.address) {
                  errors.address = "Required*";
                }
                if (!values.country) {
                  errors.country = "Required*";
                }

                if (!values.postcode) {
                  errors.postcode = "Required*";
                }

                if (!values.insurance_certificate) {
                  errors.insurance_certificate = "Required*";
                }
                // if (!values.qualification_certificate) {
                //   errors.qualification_certificate = "Required*";
                // }

                // if (!values.opening_days) {
                //   errors.opening_days = "Required*";
                // }
                // if (!values.opening_time) {
                //   errors.opening_time = "Required*";
                // }
                // if (!values.closing_time) {
                //   errors.closing_time = "Required*";
                // }

                return errors;
              }}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                setProgress(true);
                values.id = dcryptId;
                values.step_status = 2;
                console.log("dddddddddddddddddddddddddddd");
                const formData = new FormData();
                for (let key in values) {
                  formData.append(key, values[key]);
                }

                dispatch(userEditProfile(formData)).then((data) => {
                  if (data?.payload?.success) {
                    resetForm();
                    setTimeout(() => {
                      setProgress(false);
                    }, 1000);
                    navigate(
                      `/signup-time/${Encryptedid(data?.payload?.data?._id)}`
                    );
                  }
                  setSubmitting(false);
                });
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => (
                <form
                  onSubmit={(e) => {
                    // setValidateValue(true);
                    handleSubmit(e);
                  }}
                >
                  <Row>
                    <Col lg={12} className="mx-auto">
                      <div className="sign-up-details-box">
                        <div className="mt-0">
                          <div className="pagination-tab">
                            <div className="tab-dots">
                              <ul>
                                <li className="active-dot">
                                  <p>Step 1</p>
                                </li>
                                <li className="active-dot">
                                  {" "}
                                  <p>Step 2</p>
                                </li>
                                <li>
                                  {" "}
                                  <p>Step 3</p>
                                </li>
                                <li>
                                  {" "}
                                  <p>Step 4</p>
                                </li>
                                <li>
                                  {" "}
                                  <p>Step 5</p>
                                </li>
                                <li>
                                  {" "}
                                  <p>Step 6</p>
                                </li>
                              </ul>
                            </div>
                            <ProgressBar now={20} />
                          </div>
                          <h2 className="text-center choose-plan-title">
                            BUSINESS DETAILS
                          </h2>
                          <Row className="mt-5">
                            <Col lg={6}>
                              <div className="sign-detail-input">
                                <label>Business Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Type Here..."
                                  name="business_name"
                                  onChange={handleChange}
                                  value={values.business_name}
                                />
                                <span className="formik-errors">
                                  {errors.business_name &&
                                    touched.business_name &&
                                    errors.business_name}
                                </span>
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="sign-detail-input">
                                <label>Telephone Number</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Type Here..."
                                  name="telephone_number"
                                  onChange={handleChange}
                                  value={values.telephone_number}
                                />
                                <span className="formik-errors">
                                  {errors.telephone_number &&
                                    touched.telephone_number &&
                                    errors.telephone_number}
                                </span>
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="sign-detail-input">
                                <label>Email</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Type Here..."
                                  name="business_email"
                                  onChange={handleChange}
                                  value={values.business_email}
                                />
                                <span className="formik-errors">
                                  {errors.business_email &&
                                    touched.business_email &&
                                    errors.business_email}
                                </span>
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="sign-detail-input">
                                <label>Website URL</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Type Here..."
                                  name="website_url"
                                  onChange={handleChange}
                                  value={values.website_url}
                                />
                                <span className="formik-errors">
                                  {errors.website_url &&
                                    touched.website_url &&
                                    errors.website_url}
                                </span>
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="sign-detail-input post-code-types">
                                <label>Postcode</label>
                                {/* <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Postcode"
                                  name="postcode"
                                  onChange={handleChange}
                                  value={values.postcode}
                                />
                                <span className="formik-errors">
                                  {errors.postcode &&
                                    touched.postcode &&
                                    errors.postcode}
                                </span> */}
                                <InputGroup className="">
                                  <input
                                    type="search"
                                    className="form-control post-code-srch"
                                    placeholder="Type Here..."
                                    name="postcode"
                                    onChange={(e) => {
                                      setPostcode(e.target.value);
                                      handleChange(e);
                                    }}
                                    value={values.postcode}
                                  />

                                  <InputGroup.Text
                                    id="basic-addon1"
                                    className="post-code-icon"
                                    onClick={handleKeyEnter}
                                  >
                                    <img
                                      src={
                                        require("../assets/images/search-icon.svg")
                                          .default
                                      }
                                    />
                                  </InputGroup.Text>
                                  <span className="formik-errors">
                                    {errors.postcode &&
                                      touched.postcode &&
                                      errors.postcode}
                                  </span>
                                </InputGroup>

                                {/* <Form.Select
                                  aria-label="Default select example"
                                  className="form-select"
                                >
                                  <option>Services type (e.g hair)</option>
                                  <option>Services type (e.g hair)</option>
                                  <option>Services type (e.g hair)</option>
                                </Form.Select> */}
                              </div>
                            </Col>

                            <Col lg={6}>
                              <div className="sign-detail-input post-code-types">
                                <label>Address</label>
                                <select
                                  name="address"
                                  aria-label="Default select example"
                                  className="form-control form-select"
                                  onChange={(e) => {
                                    handleChange(e);
                                    handleSearch(e, setFieldValue);
                                  }}
                                  value={values.address}
                                >
                                  <option>Select Address From List</option>
                                  {addressData?.addresses?.map((item) => {
                                    return (
                                      <option
                                        value={item?.formatted_address
                                          ?.filter((item) => item !== "")
                                          .join(", ")}
                                      >
                                        {item?.formatted_address
                                          ?.filter((item) => item !== "")
                                          .join(", ")}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="sign-detail-input">
                                <label>City</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Type Here..."
                                  name="city"
                                  onChange={handleChange}
                                  value={values.city}
                                />
                                <span className="formik-errors">
                                  {errors.city && touched.city && errors.city}
                                </span>
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="sign-detail-input">
                                <label>Country</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Type Here..."
                                  name="country"
                                  onChange={handleChange}
                                  value={values.country}
                                />
                                <span className="formik-errors">
                                  {errors.country &&
                                    touched.country &&
                                    errors.country}
                                </span>
                              </div>
                            </Col>
                            {/* <Col lg={6}>
                              <div className="sign-detail-input">
                                <label>Postcode</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Postcode"
                                  name="postcode"
                                  onChange={handleChange}
                                  value={values.postcode}
                                />
                                <span className="formik-errors">
                                  {errors.postcode &&
                                    touched.postcode &&
                                    errors.postcode}
                                </span>
                              </div>
                            </Col> */}

                            <Col lg={12}>
                              <Row className="mt-4">
                                <Col lg={6}>
                                  <div className="sign-detail-input">
                                    <label>Upload Insurance Certificate</label>
                                    <div className="img-upld-box">
                                      {values.insurance_certificate == 0 && (
                                        <img
                                          className="upload-place"
                                          src={
                                            require("../assets/images/upload-placeholder.svg")
                                              .default
                                          }
                                        />
                                      )}
                                      {prevImg2 != "pdf" &&
                                        values.insurance_certificate ==
                                        "string" &&
                                        !values.insurance_certificate?.includes(
                                          "pdf"
                                        ) && (
                                          <>
                                            <img
                                              className="upload-img-icon"
                                              src={
                                                require("../assets/images/uplod-img.svg")
                                                  .default
                                              }
                                            />
                                            <p>Upload Insurance</p>
                                          </>
                                        )}

                                      <input
                                        name="insurance_certificate"
                                        type="file"
                                        onChange={(e) => {
                                          const selectedFile =
                                            e.target.files[0];
                                          if (selectedFile) {
                                            if (
                                              selectedFile.type ===
                                              "application/pdf"
                                            ) {
                                              console.log(
                                                selectedFile.type,
                                                "selectedFile.type"
                                              );
                                              setPrevImg2("pdf"); // Clear image preview
                                              setPdfFile(selectedFile);
                                            } else {
                                              setPrevImg2(
                                                URL.createObjectURL(
                                                  selectedFile
                                                )
                                              );
                                            }
                                          }

                                          setFieldValue(
                                            "insurance_certificate",
                                            selectedFile
                                          );
                                        }}
                                      />
                                      {prevImg2 ? (
                                        prevImg2 == "pdf" ? (
                                          <p className="mt-0">
                                            Document Uploaded ✅
                                          </p>
                                        ) : (
                                          <img
                                            className="view-img"
                                            src={prevImg2}
                                          />
                                        )
                                      ) : values.insurance_certificate &&
                                        typeof values.insurance_certificate ==
                                        "string" &&
                                        values.insurance_certificate?.includes(
                                          "pdf"
                                        ) ? (
                                        <p className="mt-0">
                                          Document Uploaded ✅
                                        </p>
                                      ) : (
                                        values.insurance_certificate && (
                                          <img
                                            className="view-img"
                                            src={
                                              process.env.REACT_APP_HOST_NAME +
                                              values.insurance_certificate
                                            }
                                          />
                                        )
                                      )}
                                    </div>
                                    {prevImg2 && prevImg2 == "pdf" && (
                                      <a
                                        target="_blank"
                                        href={URL.createObjectURL(pdfFile)}
                                      >
                                        View Document
                                      </a>
                                    )}
                                    {values.insurance_certificate &&
                                      typeof values.insurance_certificate ==
                                      "string" &&
                                      values.insurance_certificate?.includes(
                                        "pdf"
                                      ) && (
                                        <a
                                          target="_blank"
                                          href={
                                            process.env.REACT_APP_HOST_NAME +
                                            values.insurance_certificate
                                          }
                                        >
                                          View Document
                                        </a>
                                      )}
                                  </div>
                                </Col>
                                <Col lg={6}>
                                  <div className="user-profile-main ">
                                    <div className="property-main m-0 d-flex justify-content-between align-items-top">
                                      <h2 className="certificate p-0">
                                        Upload Qualification Certificates
                                      </h2>
                                    </div>
                                    <div
                                      style={{ cursor: "pointer" }}
                                      onClick={handleShow2}
                                      className={
                                        salonDetail?.qual_documents?.length > 0
                                          ? "overflow_prop-170"
                                          : "overflow_prop-170 no_data_scroll"
                                      }
                                    >
                                      {salonDetail?.qual_documents?.length ==
                                        0 && (
                                        <img
                                          className="upload-place"
                                          src={
                                            require("../assets/images/upload-placeholder.svg")
                                              .default
                                          }
                                        />
                                      )}
                                      {salonDetail?.qual_documents?.length >
                                        0 && (
                                          <div class="dlt-ac-btn upload-btn">
                                            <button
                                              type="button"
                                              onClick={handleShow2}
                                            >
                                              Add More
                                            </button>
                                          </div>
                                        )}

                                      {salonDetail?.qual_documents?.length >
                                        0 ? (
                                        salonDetail?.qual_documents.map(
                                          (item, i) => {
                                            const arr =
                                              item?.doc_image?.split(".");
                                            const extensionType =
                                              arr?.slice(-1)[0];

                                            return (
                                              <div
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                  window
                                                    .open(
                                                      process.env
                                                        .REACT_APP_HOST_NAME +
                                                      `${item?.doc_image}`,
                                                      "_blank"
                                                    )
                                                    .focus();
                                                }}
                                                className="row"
                                              >
                                                <div className="col-md-12">
                                                  <div className="form-group">
                                                    <div className="bg-input-shadow-c">
                                                      <div className="group-icon-text justify-content-between">
                                                        <div className="d-flex align-items-center">
                                                          <svg
                                                            width="18"
                                                            height="20"
                                                            viewBox="0 0 18 20"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                          >
                                                            <path
                                                              fill-rule="evenodd"
                                                              clip-rule="evenodd"
                                                              d="M3.5 14H13C14.8856 14 15.8284 14 16.4142 13.4142C17 12.8284 17 11.8856 17 10V5C17 3.11438 17 2.17157 16.4142 1.58579C15.8284 1 14.8856 1 13 1H5C3.11438 1 2.17157 1 1.58579 1.58579C1 2.17157 1 3.11438 1 5V16.5C1 15.1193 2.11929 14 3.5 14ZM13.4142 7.41421C14.1953 6.63317 14.1953 5.36684 13.4142 4.58579C12.6332 3.80474 11.3668 3.80474 10.5858 4.58579L8 7.17157L7.41421 6.58579C6.63317 5.80474 5.36684 5.80474 4.58579 6.58579C3.80474 7.36683 3.80474 8.63316 4.58579 9.41421L5.87868 10.7071C7.05025 11.8787 8.94975 11.8787 10.1213 10.7071L13.4142 7.41421Z"
                                                              fill="#2B3674"
                                                            />
                                                            <path
                                                              d="M16.4142 13.4142L15.7071 12.7071L15.7071 12.7071L16.4142 13.4142ZM16.4142 1.58579L15.7071 2.29289L15.7071 2.29289L16.4142 1.58579ZM13.4142 4.58579L14.1213 3.87868L14.1213 3.87868L13.4142 4.58579ZM13.4142 7.41421L12.7071 6.70711L13.4142 7.41421ZM10.5858 4.58579L9.87868 3.87868L10.5858 4.58579ZM8 7.17157L7.29289 7.87868L8 8.58579L8.70711 7.87868L8 7.17157ZM7.41421 6.58579L6.70711 7.29289H6.70711L7.41421 6.58579ZM4.58579 6.58579L5.29289 7.29289L5.29289 7.29289L4.58579 6.58579ZM4.58579 9.41421L5.29289 8.70711V8.70711L4.58579 9.41421ZM5.87868 10.7071L5.17157 11.4142L5.87868 10.7071ZM10.1213 10.7071L9.41421 10L10.1213 10.7071ZM13 13H3.5V15H13V13ZM15.7071 12.7071C15.631 12.7832 15.495 12.8774 15.0613 12.9357C14.5988 12.9979 13.9711 13 13 13V15C13.9145 15 14.701 15.0021 15.3278 14.9179C15.9833 14.8297 16.6117 14.631 17.1213 14.1213L15.7071 12.7071ZM16 10C16 10.9711 15.9979 11.5988 15.9357 12.0613C15.8774 12.495 15.7832 12.631 15.7071 12.7071L17.1213 14.1213C17.631 13.6117 17.8297 12.9833 17.9179 12.3278C18.0021 11.701 18 10.9145 18 10H16ZM16 5V10H18V5H16ZM15.7071 2.29289C15.7832 2.36902 15.8774 2.50496 15.9357 2.9387C15.9979 3.40121 16 4.02892 16 5H18C18 4.08546 18.0021 3.29896 17.9179 2.67221C17.8297 2.01669 17.631 1.38834 17.1213 0.878679L15.7071 2.29289ZM13 2C13.9711 2 14.5988 2.00212 15.0613 2.06431C15.495 2.12262 15.631 2.21677 15.7071 2.29289L17.1213 0.87868C16.6117 0.369017 15.9833 0.170272 15.3278 0.0821405C14.701 -0.00212371 13.9145 0 13 0V2ZM5 2H13V0H5V2ZM2.29289 2.29289C2.36902 2.21677 2.50496 2.12262 2.9387 2.06431C3.40121 2.00212 4.02892 2 5 2V0C4.08546 0 3.29896 -0.00212371 2.67221 0.0821405C2.01669 0.170272 1.38834 0.369017 0.87868 0.87868L2.29289 2.29289ZM2 5C2 4.02892 2.00212 3.40121 2.06431 2.9387C2.12262 2.50496 2.21677 2.36902 2.29289 2.29289L0.87868 0.87868C0.369017 1.38834 0.170272 2.01669 0.0821405 2.67221C-0.00212371 3.29896 0 4.08546 0 5H2ZM2 16.5V5H0V16.5H2ZM3.5 13C1.567 13 0 14.567 0 16.5H2C2 15.6716 2.67157 15 3.5 15V13ZM12.7071 5.29289C13.0976 5.68342 13.0976 6.31658 12.7071 6.70711L14.1213 8.12132C15.2929 6.94975 15.2929 5.05025 14.1213 3.87868L12.7071 5.29289ZM11.2929 5.29289C11.6834 4.90237 12.3166 4.90237 12.7071 5.29289L14.1213 3.87868C12.9497 2.70711 11.0503 2.70711 9.87868 3.87868L11.2929 5.29289ZM8.70711 7.87868L11.2929 5.29289L9.87868 3.87868L7.29289 6.46447L8.70711 7.87868ZM6.70711 7.29289L7.29289 7.87868L8.70711 6.46447L8.12132 5.87868L6.70711 7.29289ZM5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.70711 7.29289L8.12132 5.87868C6.94975 4.70711 5.05025 4.70711 3.87868 5.87868L5.29289 7.29289ZM5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289L3.87868 5.87868C2.70711 7.05025 2.70711 8.94975 3.87868 10.1213L5.29289 8.70711ZM6.58579 10L5.29289 8.70711L3.87868 10.1213L5.17157 11.4142L6.58579 10ZM9.41421 10C8.63316 10.781 7.36684 10.781 6.58579 10L5.17157 11.4142C6.73367 12.9763 9.26633 12.9763 10.8284 11.4142L9.41421 10ZM12.7071 6.70711L9.41421 10L10.8284 11.4142L14.1213 8.12132L12.7071 6.70711ZM8 18H3.5V20H8V18ZM0 16.5C0 18.433 1.567 20 3.5 20V18C2.67157 18 2 17.3284 2 16.5H0Z"
                                                              fill="#2B3674"
                                                            />
                                                          </svg>

                                                          <p>
                                                            {item?.doc_title}
                                                          </p>
                                                        </div>
                                                        <p className="padf">
                                                          {extensionType}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          }
                                        )
                                      ) : (
                                        <p className="no_data text-center"></p>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col lg={6}>
                              <div className="sign-detail-input">
                                <label>Insurance Expiry Date</label>
                                <input
                                  type="date"
                                  class="form-control"
                                  placeholder="Type Here..."
                                  name="insurance_expiry"
                                  onChange={handleChange}
                                  value={values.insurance_expiry}
                                  min={new Date().toISOString().split("T")[0]}
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>

                        <div className="mt-0">
                          <Row className="mt-2">
                            <Col lg={4}>
                              <div className="category-select">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  name="lgbt_friendly"
                                  value={values.lgbt_friendly ? 1 : 0}
                                  onChange={handleChange}
                                  checked={values.lgbt_friendly}
                                />

                                <label>LGBT Friendly</label>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={12}>
                              <div className="Salon-Signup-btn">
                                {/* <Link to="/signup" className="me-3 back-sign">
                                  Back
                                </Link> */}
                                <button type="submit">Continue</button>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </form>
              )}
            </Formik>
          </Container>
          <Modal show={show2} onHide={handleClose2}>
            <Modal.Header closeButton>
              <Modal.Title>Upload Documents</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="documents-main-form">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ values, setFieldValue, isSubmitting }) => (
                    <FormikForm>
                      <FieldArray name="qual_documents">
                        {({ insert, remove, push }) => (
                          <div>
                            {values.qual_documents.length > 0 &&
                              values.qual_documents.map((doc, index) => (
                                <div className="documents-upload" key={index}>
                                  <div className="form-group">
                                    <label>Document Title</label>
                                    <Field
                                      name={`qual_documents[${index}].doc_title`}
                                      type="text"
                                      className="form-control"
                                      placeholder="Type Here...."
                                    />
                                    <ErrorMessage
                                      name={`qual_documents[${index}].doc_title`}
                                      component="div"
                                      className="field-error"
                                    />
                                  </div>
                                  <div className="upload-input">
                                    <input
                                      name={`qual_documents[${index}].doc_image`}
                                      type="file"
                                      className="form-control"
                                      //accept="application/pdf"
                                      onChange={(event) => {
                                        const formData = new FormData();
                                        formData.append(
                                          "image",
                                          event.currentTarget.files[0]
                                        );
                                        dispatch(uploadImage(formData)).then(
                                          (item) => {
                                            console.log(
                                              item,
                                              "itemitemitemitemitemitem"
                                            );
                                            setFieldValue(
                                              `qual_documents[${index}].doc_image`,
                                              item?.payload?.filename
                                            );
                                          }
                                        );
                                      }}
                                    />
                                    <ErrorMessage
                                      name={`qual_documents[${index}].doc_image`}
                                      component="div"
                                      className="field-error"
                                    />
                                  </div>
                                  <button
                                    type="button"
                                    onClick={() => remove(index)}
                                    className="cmn-doc"
                                  >
                                    Remove
                                  </button>
                                </div>
                              ))}
                            <button
                              type="button"
                              className="cmn-doc"
                              onClick={() =>
                                push({ doc_title: "", doc_image: "" })
                              }
                            >
                              Add Document{" "}
                              <img
                                src={require("../assets/images/addimage.png")}
                              />
                            </button>
                          </div>
                        )}
                      </FieldArray>
                      <div className="d-flex justify-content-center">
                        <button
                          type="submit"
                          className="cmn-doc"
                          disabled={isSubmitting}
                        >
                          Submit
                        </button>
                      </div>
                    </FormikForm>
                  )}
                </Formik>
              </div>
            </Modal.Body>
          </Modal>
        </section>

        {/* Sign Up Main Text end */}

        {/* footer section start  */}
        {progress && <Loader />}
        {/* footer section end  */}
      </Layout>
    </>
  );
}
